import React from 'react';

const OutcomeGoalContext = React.createContext({
  outcome: {},
  activeGoals: [],
  allGoals: [],
  toggleGoal: () => null,
});

export default OutcomeGoalContext;
